import { render, staticRenderFns } from "./BuildingInvoiceModal.vue?vue&type=template&id=2a62027e&scoped=true&"
import script from "./BuildingInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./BuildingInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62027e",
  null
  
)

export default component.exports